import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import './CodeEditor.css'

import Tests from '../Tests/Tests'
import Result from '../Result/Result'
import { keywords } from '../../utils/constants'

function CodeEditor({ taskNamber,  sendSolve, isSolvePartOpen, tests, isSanding, isTestsCame}) {
  
  const [isFormValid, setIsFormValid] = React.useState(false)
  const [isError, setIsError] = React.useState(true)
  const [lineCount, setLineCount] = React.useState(1)

  const [isSomethingInLocalStorage, setIsSomethingInLocalStorage] = React.useState(false)

  const testsRef = React.useRef(null);

  React.useEffect(() => {
    if (testsRef.current) {
      testsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [tests]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const tasks = JSON.parse(localStorage.getItem("tasks"))
  
  const navigate = useNavigate()

  function goBack() {
    navigate(-1);
  }
  
  let { _id } = useParams();

  const task = tasks.find(f => f.id == _id)

  const [value, setValue] = React.useState(task.precode)

  React.useEffect(() => {
    if(localStorage.getItem(`value${_id}`)!= null){
      setIsSomethingInLocalStorage(true)
      setValue(localStorage.getItem(`value${_id}`))
      setLineCount(localStorage.getItem(`line${_id}`))  
    } else {
      setIsSomethingInLocalStorage(false)
    }
  }, [])

  function handleChange(e) {
    if(!e.target.value){
      setIsError(true)
      setValue(e.target.value)
      const newCode = e.target.value
      const lines = newCode.split("\n")
      setLineCount(lines.length)
      

    } else {
      setIsError(false)
      setValue(e.target.value)
     
      localStorage.setItem(`value${_id}`, e.target.value)

      const newCode = e.target.value
      const lines = newCode.split("\n")
      setLineCount(lines.length)

      localStorage.setItem(`line${_id}`, lines.length)
    }
  }

  React.useEffect(() => {
    if(!value){
      setIsFormValid(false)

    } else {
      setIsFormValid(true)

    }
  }, [value])

  function handleSubmit(e) {
    e.preventDefault();
    if(!value) {
      console.log('Отправьте код')
    }else{
    const numberValue = parseInt(_id);
    sendSolve(numberValue, value);
    }
  }

  const colorizeText = (text) => {

    const commentStart = "//";
    const lines = text.split('\n')
    const reg = /^[\t]?["'][\s\S]+["']$/
    const digitRegex = /^\d+$/
   
    const coloredLines = lines.map((line, index) => {
      if (line.trim().startsWith(commentStart) ) {
        return (
          <span key={index} className="keyword-green">{line + '\n'}</span>
        );
      }else{
        let isItComment = false
        const words = line.split(' ');

        const coloredWords = words.map((word, index) => {
         if (word.slice(0,2) === '//') {
            isItComment = true
            return (
              <span key={index} className="keyword-green">{word} </span>
            );
          }else if(isItComment===true){
            return (
              <span key={index} className="keyword-green">{word} </span>
            );
          }else if(keywords.includes(word.replace(/[^a-zA-Zа-яА-Я\d]/g, '').toLowerCase())
           ) {
            return (
              <span key={index} className="keyword-red">{word} </span>
            );
          } else if(word.match(reg) || digitRegex.test(word)) {
              return (
                <span key={index}>{word} </span>
              );
          } else {
            return (
              <span key={index} className='keywords-blue'>{word} </span>
            ); 
          }
        });

        return (
          <div key={index} className='line'>{coloredWords}</div>
        );
      }
    });

    return coloredLines;
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault();
  
      // Получаем текущее значение текста
      const currentValue = e.target.value;
  
      // Получаем позицию курсора
      const selectionStart = e.target.selectionStart;
  
      // Создаем новое значение текста с вставленными пробелами
      const updatedValue =
        currentValue.substring(0, selectionStart) +
       // '\u2002\u2002\u2002\u2002' + ' ' + // 4 пробела вместо табуляции
      " \t " +
        currentValue.substring(e.target.selectionEnd);
  
      // Устанавливаем новое значение в textarea
      e.target.value = updatedValue;
      setValue(e.target.value)
      // Перемещаем курсор на правильное место
      const newPosition = selectionStart + 3; // Перемещаем на 4 символа вправо
      e.target.setSelectionRange(newPosition, newPosition);
    }
  };

  return (
    <section className="training__wrapper"> 
    <div className="training">
      <div className='training__task-part'>
        <button className='training__back-btn' onClick={goBack}>&larr; Вернуться назад</button>
        <div className="training__task">
          <h3 className="training__name">{task.name}</h3>
          <p className="training__text">{task.text}</p>
          <p className="training__exsample">{task.example}</p>
        </div>
      </div>  

      <div className='training__solve-part'>
        <p className="training__title">Вводите ваше решение тут:</p>
        {isSanding? 
          <p className="training__sanding-message">Решение отправляется ...</p>
        :
        <form onSubmit={handleSubmit} className='training__form'> 
          <div className="training__line-count-and-textarea-container">
            <div className="line-count">
              {Array.from({ length: lineCount }, (_, index) => (
                <div key={index} className="line-number">
                {index + 1}
                </div>
              ))}
            </div>

            <div 
              className={isSolvePartOpen? 'training__textarea' : 'training__textarea_closed'}           
            >
              <pre 
                className="colored-text"
              >{colorizeText(value)}</pre>
              
            </div>
            
            <div className='textarea__invisible'>
              <textarea 
                onKeyDown={handleKeyDown}
                className='textarea'
                value={value}
                type="text"
                onChange={handleChange}
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                tabIndex="0"
              ></textarea>
            </div>
            
          </div>

          <button 
            className={`training__submit-btn ${isFormValid && 'training__submit-btn_active'}`}
            type="submit"
            disabled={!isFormValid}
            ref={testsRef}
            >
              Отправить
          </button>
        </form>
        }
      </div>
      </div>
      {isTestsCame && (taskNamber == _id)?
        <>
          <Result
            tests={tests}
          />
          <Tests
            tests={tests}
          />
        </>
        : 
        <></>
      }
    </section>
  );
}

export default CodeEditor;